// EmailSentNode.js
import { Handle, Position } from '@xyflow/react';
import { Box, Paper, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import EmailIcon from '@mui/icons-material/Email';

const NodePaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  minWidth: 200,
  backgroundColor: '#ffffff',
  border: `2px solid ${theme.palette.black['100']}`,
  borderRadius: theme.spacing(1),
  boxShadow: theme.shadows[3],
  '&:hover': {
    boxShadow: theme.shadows[6],
  }
}));

const StyledHandle = styled(Handle)(({ theme }) => ({
  width: 10,
  height: 10,
  backgroundColor: "black",
    border: "white",
}));

export function EmailSentNode() {
  return (
    <NodePaper elevation={3}>
      <StyledHandle
        type="target"
        position={Position.Top}
        isConnectable={true}
      />
      
      <Box sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        gap: 1,
        py: 1 
      }}>
        <EmailIcon color="primary" />
        <Typography variant="subtitle1" color="primary">
          Email Sent
        </Typography>
      </Box>

      <StyledHandle
        type="source"
        position={Position.Bottom}
        id="b"
        isConnectable={true}
      />
    </NodePaper>
  );
}